<script setup lang="ts">
const { t } = useI18n()
const prizeMoney = usePrizeMoney()
const image = import.meta.glob('~/assets/prizes/2025/prize-grid.png', { eager: true, import: 'default' })
</script>

<template>
  <div class="relative h72 overflow-hidden from-orange-500/90 via-red-500/90 to-rose-500/90 bg-gradient-linear bg-cover bg-left bg-no-repeat lg:h112 sm:h64 sm:rounded-xl">
    <div class="absolute grid grid-cols-2 h-full w-full">
      <div class="absolute right-0 top-0 col-span-1 translate-x-1/2 translate-y-1/80 lg:translate-x-1/10 lg:-translate-y-1/12 md:translate-x-1/3-translate-y-1/4 sm:translate-x-1/3 sm:-translate-y-1/20">
        <NuxtImg
          :src="image['/assets/prizes/2025/prize-grid.png'] as string"
          class="w96 rotate-12 lg:w164 md:w128"
          width="656"
          height="566"
          loading="lazy"
          alt="prizes"
        />
      </div>

      <div class="col-span-1 my-auto flex flex-col pl8 pr6 lg:pl16">
        <div class="mb4 sm:mb8">
          <span class="text-base text-white font-bold lg:text-3xl sm:text-2xl">
            {{ t('prize.your_order_could_be_winning') }}
          </span>
        </div>

        <span class="text-sm text-white fw600 lg:text-2xl sm:text-xl">
          {{ t('prize.win_up_to', [prizeMoney]) }}
        </span>
      </div>
    </div>
  </div>
</template>
